import _ from "lodash";

export default function reducer(state = {
    selected: {},
    events: []
}, action) {
    switch (action.type) {
        case "SET_CALENDAR_SELECTED": {
            return { 
                ...state, 
                selected: action.event
            }
        }

        case "SET_CALENDAR_EVENTS": {
            return { 
                ...state, 
                events: action.events
            }
        }

        default:
            return state;
    }
}